import { EnvironmentConfig } from '../../models/types';

class EnvironmentService {
  private config!: EnvironmentConfig;
  private loadingPromise: Promise<EnvironmentConfig> | null = null;

  async loadConfig(): Promise<EnvironmentConfig> {
    if (this.config) {
      return this.config;
    }

    if (!this.loadingPromise) {
      this.loadingPromise = this.loadConfigInternal();
    }

    return this.loadingPromise;
  }

  private async loadConfigInternal(): Promise<EnvironmentConfig> {
    const response = await fetch('/config/environment.json');

    if (!response.ok) {
      throw new Error(`Failed to load environment config: ${response.status}`);
    }

    const config = await response.json();

    if (!config) {
      throw new Error('Environment configuration is empty');
    }

    this.config = config;
    this.loadingPromise = null;

    return config;
  }

  getConfig(): EnvironmentConfig {
    return this.config;
  }
}

export const environmentService = new EnvironmentService();
